(function () {
  // Keeps a product card's displayed price in sync with the variant chosen in
  // the card dropdown, so the shopper never sees a "From {lowest}" price that
  // differs from the variant that will actually be added to the cart.

  function syncCard(select) {
    var card = select.closest('.product-item');

    if (!card) {
      return;
    }

    var option = select.options[select.selectedIndex];

    if (!option) {
      return;
    }

    var priceList = card.querySelector('.product-item__price-list[data-card-price-list]') ||
      card.querySelector('.product-item__price-list');

    if (!priceList) {
      return;
    }

    var priceWrap = priceList.querySelector('[data-card-price]');
    var priceAmount = priceList.querySelector('[data-card-price-amount]');
    var compareWrap = priceList.querySelector('[data-card-compare]');
    var compareAmount = priceList.querySelector('[data-card-compare-amount]');

    var priceMoney = option.getAttribute('data-price-money');
    var compareMoney = option.getAttribute('data-compare-money');

    if (priceAmount && priceMoney) {
      priceAmount.textContent = priceMoney;
    }

    var onSale = !!compareMoney;

    if (priceWrap) {
      priceWrap.classList.toggle('price--highlight', onSale);
    }

    if (compareWrap) {
      if (onSale) {
        if (compareAmount) {
          compareAmount.textContent = compareMoney;
        }

        compareWrap.style.display = '';
      } else {
        if (compareAmount) {
          compareAmount.textContent = '';
        }

        compareWrap.style.display = 'none';
      }
    }

    syncCardImage(card, option);
  }

  function syncCardImage(card, option) {
    var newImage = option.getAttribute('data-variant-image');

    if (!newImage) {
      return;
    }

    var img = card.querySelector('.product-item__primary-image');

    if (!img || img.getAttribute('src') === newImage) {
      return;
    }

    // Pin to this single image so lazysizes doesn't rebuild a responsive
    // srcset from the original product image template.
    img.removeAttribute('data-widths');
    img.setAttribute('data-src', newImage);
    img.setAttribute('data-srcset', newImage);
    img.src = newImage;
    img.srcset = newImage;
  }

  function bind(select) {
    if (select.__cardPriceBound) {
      return;
    }

    select.__cardPriceBound = true;
    select.addEventListener('change', function () {
      syncCard(select);
    });

    // Sync once on load in case the browser restored a non-default selection.
    syncCard(select);
  }

  function run(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var selects = scope.querySelectorAll('.product-item__variant-select');
    Array.prototype.forEach.call(selects, bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run(document);
    });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    run(event.target || document);
  });
})();
